import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="preguntas" className="w-full bg-cream-50 py-16 lg:py-24" data-id="element-37" data-mp="1lb92x2tlfqlp">
      <div className="mx-auto max-w-3xl px-5 lg:px-8" data-id="element-38" data-mp="1gcpe8unm80pn">
        <h2 className="display-tight font-display text-4xl font-extrabold text-forest-800 sm:text-5xl" data-id="element-39" data-mp="1ge0kd14j9kjx">
          Preguntas frecuentes
        </h2>

        <dl className="mt-10 divide-y divide-cream-200 border-y border-cream-200" data-id="element-40" data-mp="291d1gvrxd05u">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} data-id="element-41" data-mp="24436l0lrnwam" data-mpi={i}>
                <dt data-id="element-42" data-mp="1z3oy5hg96kc2">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-5 text-left font-display text-lg font-bold text-forest-800 transition-colors duration-150 ease-out hover:text-forest-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-600" data-id="element-43" data-mp="1z25i9ryiebat">
                    {faq.q}
                    {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-44" data-mp="kiuym68607p3" /> : <PlusIcon className="h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-45" data-mp="bi6fwy7ttj5v" />}
                  </button>
                </dt>
                {isOpen && <dd className="pb-6 pr-10 leading-relaxed text-forest-700/80" data-id="element-46" data-mp="1sv7zewoekjk">
                    {faq.a}
                  </dd>}
              </div>;
        })}
        </dl>
      </div>
    </section>;
}